import React from "react";
import { useLocation } from "@reach/router";
import Layout from "@components/layout";
import SEO from "@components/seo";
import { Link } from "gatsby";
import * as c from "@pages/404.module.scss";

const NotFoundPage = () => {
  const location = useLocation();
  const isLearnRoute = location.pathname.startsWith("/learn");

  const message = isLearnRoute
    ? "Sorry, this page does not exist or has moved."
    : "Looks like you just hit a page that doesn't exist. Sorry about that.";

  // Use fragment instead of Layout for Learning Center routes
  const Wrapper = isLearnRoute ? React.Fragment : Layout;

  return (
    <Wrapper>
      <SEO title="404: Not found" noIndex />
      <div className={c.container}>
        <h1 className={c.title}>Page Not Found.</h1>
        <p className={c.text}>{message}</p>
        {isLearnRoute && (
          <p className={c.text}>
            Go to the{" "}
            <Link className={c.link} to="/learn">
              Learning Center
            </Link>{" "}
            homepage or use the <strong>Search</strong> box to find what you need.
          </p>
        )}
      </div>
    </Wrapper>
  );
};

export default NotFoundPage;
